// Invitación pendiente entre la landing /join/:teamId/:token y el alta.
// Se guarda en sessionStorage para que el formulario de registro (Login)
// pueda inyectar el token en options.data del signUp, y handle_new_user meta
// al nuevo usuario directamente en el equipo invitado.

export interface PendingInvite {
  teamId: string;
  token: string;
  teamName: string;
}

const KEY = 'bk_pending_invite';

export function setPendingInvite(invite: PendingInvite): void {
  sessionStorage.setItem(KEY, JSON.stringify(invite));
}

export function getPendingInvite(): PendingInvite | null {
  try {
    return JSON.parse(sessionStorage.getItem(KEY) || 'null') as PendingInvite | null;
  } catch {
    return null;
  }
}

export function clearPendingInvite(): void {
  sessionStorage.removeItem(KEY);
}
